export default "__VITE_ASSET__Cr9ol14I__"